const routes = [


	//---- Resource Planning
	{
		path: '/module.resource-planning',
		name: "module.resource-planning-index",
		component: () => import("/module.resource-planning/index.vue"),
		meta: { layout: "primary", layoutContainer: "none", module: "resourcing", parentRouteName: "", pageTitle: "Resource Planning" }
	},

	{
		path: '/module.resource-planning/open-buckets',
		name: "module.resource-planning-open-buckets",
		component: () => import("/module.resource-planning/open-buckets.vue"),
		meta: { layout: "primary", module: "resourcing", parentRouteName: "module.resource-planning-index", pageTitle: "Resource Planning > Open Buckets" }
	},

	{
		path: '/module.resource-planning/conflicts',
		name: "module.resource-planning-conflicts",
		component: () => import("/module.resource-planning/conflicts.vue"),
		meta: { layout: "primary", module: "resourcing", parentRouteName: "module.resource-planning-index", pageTitle: "Resource Planning > Conflicts" }
	},

	{
		path: '/module.resource-planning/import',
		name: "module.resource-planning-import",
		component: () => import("/module.resource-planning/import-baseline.vue"),
		meta: { layout: "primary", module: "resourcing", parentRouteName: "module.resource-planning-index", pageTitle: "Resource Planning > Import baseline" }
	},

	{
		path: '/module.resource-planning/person/:userId',
		name: "module.resource-planning-person",
		component: () => import("/module.resource-planning/person-focus.vue"),
		meta: { layout: "primary", module: "resourcing", parentRouteName: "module.resource-planning-index", pageTitle: "Resource Planning > {personName}" }
	},

	// Deliberately NOT nested under /module.resource-planning: every user gets this
	// regardless of planning permission (it's the individual's own read-only view).
	{
		path: '/my-plan',
		name: "resource-planning-my-plan",
		component: () => import("/module.resource-planning/my-plan.vue"),
		meta: { layout: "primary", module: "resourcing", parentRouteName: "", pageTitle: "My Plan" }
	},

]


export default routes;
